import ShoppingCar from "./ShoppingCar";
export default {
  state: {
    shoppingCar: new ShoppingCar([]),
  },
  getters: {
    shoppingCar: (state) => state.shoppingCar,
  },
  mutations: {
    setShoppingCar: (state, data) => (state.shoppingCar = data),
  },
};
